<template>
  <div id="home">
    <div class="w3-row">
      <div class="w3-container">
        <!-- pic & name & level -->
        <div class="w3-row">
          <div class="w3-col s7">
            <div class="w3-col s6">
              <img id="pic" :src="picture"> <!--:src="picture"-->
              <br />
            </div>
            <div id="userProfile" class="w3-col s6">
              <p id="userName">{{ displayname }}</p> <!---->
              <p id="lv">等級： {{ level }}</p>
            </div>

            <!-- point & share & medal -->
            <div>
              <p>任務點數： {{ point }}</p>
              <p>分享隊員： {{ share }}</p>
              <p>榮譽勳章</p>
              <img id="medal" src="../assets/diamond.png">
            </div>
          </div>
          <!-- button -->
          <div id="btn" class="w3-col s5">
          <br />
            <!--<a :href="'line://msg/text/?親愛的朋友，我要邀請你一起加入Beauty美妝生活圈 的LINE好友，最新美妝潮流都在這裡！%0D%0A%0D%0Aline://app/1610553524-JbE9B9WV?c='+this.c+'&rec='+this.userId"><button id="able" v-on:click="recommend" :disabled="isDisable">邀請好友</button></a>-->
            <router-link :to="{name:'recommend'}">
              <button id="able" :disabled="isDisable">邀請戰友</button>
              <!--v-on:click="recommend" :disabled="isDisable"-->
            </router-link>
            <button id="disable">任務攻略</button>
            <button id="disable">獎勵兌換</button>
            <button id="disable">會員條碼</button>
          </div>
        </div>
      </div>

      <!-- blank -->
      <div class="w3-container">
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  data() {
    return {
      c: window.location.search.split('c=')[1]
    }
  },
  methods: {
    // 取得使用者資訊 (dispalyName, pictureUrl, userId)//
    create: function() {
      this.$store.dispatch('getUserid', true)
    },
    // 記錄推薦人USID //
    recommend: function() {
      this.$store.dispatch('recommend', 
      {
        c: this.c
      })
      // 防止重複點擊按鈕
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 2000)
    },
    // 查詢成功推薦人數 //
    numOfshare: function() {
      this.$store.dispatch('numOfshare',
      {
        c: this.c
      })
    }
  },
  computed: {
    ...mapGetters({
      userId: 'userId'
    }),
    ...mapGetters({
      point: 'point'
    }),
    ...mapGetters({
      level: 'level'
    }),
    ...mapGetters({
      share: 'share'
    }),
    ...mapGetters({
      displayname: 'displayname'
    }),
    ...mapGetters({
      picture: 'picture'
    })
  },
  mounted() {
    this.create()
    this.numOfshare()
  }
}
</script>

<style>
@import url("https://www.w3schools.com/w3css/4/w3.css");
* {
  font-family: "微軟正黑體";
  font-weight: bolder;
  background-color: #444444;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: white;
}
p {
  color: white;
  font-size: 16px;
  padding: 5px;
  text-align: left;   
  line-height: 8px; 
}
#pic {
  border-radius: 50%;
  margin-top: 10px;
  margin-left: 10px;
}
#userName {
  white-space: nowrap;
}
#lv {
  white-space: nowrap;
}
#btn {
  margin-top: 35px;
}
button {
  float: right;
  /*background-color: #367CC0;*/
  color: white;
  font-weight: bolder;
  font-family: "微軟正黑體";
  width: 70%;
  padding: 6px 10px;
  margin-bottom: 6px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border: 2px white solid;
  border-radius: 6px;
}
#able {
  background-color: #B51700;
}
#disable {
  background-color: #929292;
}
img {
  width: 61%;
}
#medal {
  width: 26%;
  margin-left: 10px;
}
#logo {
  margin-top: 25px;
  width: 45%;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue